/* If you edit this file, please remove this header and clean up the resulting eslint errors.
*/
/* eslint-disable
  import/named,
  import/no-extraneous-dependencies
*/
import './index.scss';
import React from 'react';
import CheckPlatform from 'common/utils/check-platform';
import TopBarMenu from 'hellosign/components/home/top-bar-menu';
import {
  topBarMenuLinkData,
  dropDownMenuLinkData,
} from 'hellosign/components/home/top-bar-menu/menu-data/google-marketing';
import LogoImgSrc from 'common/images/logo@2x.png';


export default function GoogleMarketingHeader(props) {

  // Expect to need to pass these props:
  // loginForm, forgotPasswordForm, signupForm

  const platform = CheckPlatform();

  let topBarMenu;
  if (platform === 'desktop') {
    topBarMenu = <TopBarMenu
      hideDropDownMenu={true}
      topBarMenuLinkData={topBarMenuLinkData}
      dropDownMenuLinkData={dropDownMenuLinkData}
      {...props} />;
  }

  const homepageLink = 'http://hellosign.com';
  const baseClass = `m-external-google-marketing-header ${platform}`;

  return (
    <div className={baseClass}>
      <a href={homepageLink}>
        <img src={LogoImgSrc} />
      </a>
      { topBarMenu }
    </div>
  );
}
